/* ========================================================================
   Navigation
 ========================================================================== */

app.navigation = (function () {
  'use strict';

  // function initScrollToAnchor() {
  //   const links = document.querySelectorAll('a[href^="#"]');

  //   links.forEach((link) => {
  //     link.addEventListener('click', (event) => {
  //       event.preventDefault();

  //       if (link.getAttribute('href') !== '#content') {
  //         util.scrollTo(link, { offset: 24 });
  //       } else {
  //         util.scrollTo(link);
  //       }
  //     });
  //   });
  // }

  function initMenu() {
    const trigger = document.querySelector('[data-main-nav-trigger]');
    const container = document.querySelector('[data-main-nav-container]');
    const body = document.querySelector('body');

    if (!trigger || !container) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      if (trigger.classList.contains('is-active') === false) {
        trigger.classList.add('is-active');
        container.classList.add('is-active');
        body.classList.add('has-open-menu');

        // a11y: update aria attributes
        trigger.setAttribute('aria-label', trigger.dataset.closeText);
        trigger.setAttribute('aria-expanded', true);
      } else {
        trigger.classList.remove('is-active');
        container.classList.remove('is-active');
        body.classList.remove('has-open-menu');

        // a11y: update aria attributes
        trigger.setAttribute('aria-label', trigger.dataset.openText);
        trigger.setAttribute('aria-expanded', false);
      }
    });
  }

  // Expose public functions and variables
  return {
    // initScrollToAnchor: initScrollToAnchor,
    initMenu: initMenu,
  };
})();
